/**
 * Métodos para manipulación de las rutas url.
 *
 * Permite operaciones para la construcción de rutas a partir de sus componentes.
 *
 * @export
 * @class UrlUtils
 */
export default class UrlUtils {
  /**
   * Permite armar una ruta URL concatenado sus partes.
   *
   * Controla si las partes presentan / al inicio o al final para tener en cuenta
   * al momento de construir la ruta concatenada
   *
   * @static
   * @param {string} base Ruta base de la URL a construir
   * @param {string} portion Segunda porción de la ruta
   * @return {*}  {URL} Objeto URL con la ruta construida por la concatenación de sus
   * componentes
   * @memberof UrlUtils
   */
  static urlConcat(base: string, portion: string): URL {
    // se quitan los finales de ruta y principios para luego concatenar
    const baseLocal = base.endsWith('/') ? base.slice(0, -1) : base;
    const portionLocal = portion.startsWith('/') ? portion.slice(1) : portion;

    return new URL(portionLocal, baseLocal + '/');
  }
}
